import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import {
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  styled,
  CardActionArea,
} from '@mui/material';
import Footer from '../navbar/Footer';

const bulletins = [
  {
    title: "Bulletins mensuels des prix",
    link: "/bulletinsPrix", 
    description: "Ce bulletin fournit une analyse mensuelle des prix pour différents biens et services."
  },
  {
    title: "Bulletins trimestriels des statistiques des faits d'état civil",
    link: "/bulletinsEtatCivil", 
    description: "Une compilation trimestrielle des statistiques concernant les faits d'état civil."
  },
  {
    title: "Bulletins du commerce extérieur de marchandises",
    link: "/bulletinCommerceExterieur", 
    description: "Rapport sur les échanges de marchandises avec l'extérieur, présentant les tendances du commerce."
  },
  {
    title: "Bulletins de conjoncture",
    link: "/BulletinConjoncture", 
    description: "Analyse de la conjoncture économique sur une période donnée."
  },
  {
    title: "Notes de conjoncture",
    link: "/notesConjoncture",
    description: "Notes brèves sur la situation économique actuelle."
  },
];

const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  transition: 'transform 0.2s ease-in-out',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: `0px 4px 10px rgba(0, 0, 0, 0.1)`
  },
}));

const StyledCardActionArea = styled(CardActionArea)({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  padding: theme.spacing(2),
  '&:last-child': {
    paddingBottom: theme.spacing(2),
  },
}));

const TitleTypography = styled(Typography)(({ theme }) => ({
  color: 'green',
  fontWeight: 'bold',
  marginBottom: theme.spacing(1),
}));

const DescriptionTypography = styled(Typography)(({ theme }) => ({
  color: '#555',
}));

function Bulletin() {
  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '20px' }}>
      <NavigationBar />
      <Typography variant="h4" align="center" gutterBottom style={{ color: 'green' }}>
      <br />
        </Typography>
      <Container>
        <Typography variant="h4" align="justify" gutterBottom style={{ color: 'green' }}>
          Bulletins
        </Typography>
        <Typography variant="body1" align="justify" paragraph>
          Les bulletins publiés par l’Institut National de la Statistique du Burundi fournissent des informations d’intérêt public sur une période mensuelle ou trimenstrielle
        </Typography>

        <Grid container spacing={2}>
          {bulletins.map((bulletin, index)=>(
            <Grid item xs={12} sm={6} md={4} key={index}>
              <StyledCard>
                <StyledCardActionArea href={bulletin.link}  rel="noopener noreferrer">
                  <StyledCardContent>
                    <TitleTypography variant="h6" component="div">
                      {bulletin.title}
                    </TitleTypography>
                    <DescriptionTypography variant="body2">
                      {bulletin.description}
                    </DescriptionTypography>
                  </StyledCardContent>
                </StyledCardActionArea>
              </StyledCard>
            </Grid>
          ))}
        </Grid>
      </Container>
      <br />
      <br />
      <Footer />
    </div>
  );
}

export default Bulletin;